import InfoIcon from '@mui/icons-material/Info';
import { Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import { default as Typography } from '@mui/material/Typography';

interface Props {
  helperText?: string;
}

export const FieldInfoMessage: React.FC<Props> = ({ helperText }) => {
  return (
    <Grid
      container
      direction={'row'}
      justifyContent={'flex-start'}
      alignItems="center"
    >
      {!!helperText && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            ml: 2,
            mb: 2
          }}
        >
          <InfoIcon />
          <Typography variant="caption">{helperText}</Typography>
        </Box>
      )}
    </Grid>
  );
};
